import {ABSHtmlElement} from "../abstract/ABSHtmlElement.js";

export class LocalTime extends ABSHtmlElement{
    /***
     * HTML local-time element to display time correct locale and correct timezone<br>
     * Attributes: <br>
     * (required)  data-time="1233321" — UTC time <br>
     *             data-new-line="1"|"true" — Add new line between date and time<br>
     *             data-only-date="1"|"true" — Show only the date
     */
    constructor() {
        super();
        this
            .onAttributeChange('data-time', this.updateContent.bind(this))
            .onAttributeChange('data-title', this.updateContent.bind(this))
            .onAttributeChange('data-new-line', this.updateContent.bind(this))
            .onAttributeChange('data-only-date', this.updateContent.bind(this))
            //с предлогом "в"
            .onAttributeChange('data-preposition', this.updateContent.bind(this)) 
    }
    connectedCallback(){
        this.updateContent();
    }
    protected updateContent(){
        this.title = (this.dataset['title']??'$0').replace('$0', this.dateTimeFull);
        (this.innerHTML = this.timeTitle)

    }
    static observedAttributes = ['data-time', 'data-new-line', 'data-only-date', 'data-title']
    get utcTime(): number{
        return +(this.dataset['time'] ?? +new Date/1000);
    }
    get timeTitle(){
        if(!this.dataset["preposition"])
            return convertTime(this.utcTime, !!this.dataset['newLine'], !!this.dataset['onlyDate']);
        
        return this.withPreposition;
    }
    get dateTimeFull(){
        return convertTimeFull(this.utcTime);
    }
    get withPreposition(){
        const fullTime = convertTimeFull(this.utcTime).split(" ");
        const date = fullTime[0].split(".");
        const time = fullTime[1].split(":").slice(0,2);
        const formatedTime = time.join(":")
        const formatedDate = [...date.slice(0,2), date[2].slice(2,4)].join(".")
        return `${formatedDate} в ${formatedTime}`;
    }
}

if(customElements.get('local-time')) console.warn("Element local-time already exists... This shouldn't happen");
else customElements.define('local-time', LocalTime)
